import { http } from '@/providers/apis/http';
import { competencySerializer } from '@/providers/serializers/competency/competency';
import { CompetencyModel } from '@/models/taxonomy/competency';
import { FacetMatrix } from '@/models/proficiency/facet-matrix';


export class CompetencyModelAPI {

  private static INSTANCE = new CompetencyModelAPI();

  private namespace = 'api/competency/model';

  private cmNamespace = '/v1';


  static get instance() {
    return this.INSTANCE;
  }

  public fetchCompetencyModelList(offset: number, limit: number, userId: any, tenantId: any, subjectCode: any):
    Promise<CompetencyModel[]> {
    let endpoint = `${this.namespace}/v1/list?offset=` + offset + '&limit=' + limit;
    if (tenantId !== undefined && tenantId !== '') {
      endpoint = endpoint + '&tenantId=' + tenantId;
    }
    if (userId !== undefined && userId !== '') {
      endpoint = endpoint + '&userId=' + userId;
    }

    if (subjectCode !== undefined && subjectCode !== '' && subjectCode !== null) {
      endpoint = endpoint + '&subjectCode=' + subjectCode;
    }

    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return competencySerializer.serializeCompetencyModel(response.data);
    });
  }

  public upoadFile(formData: any, userId: any, tenantId: any, progression: any, subjectCode: any): Promise<any> {
    let endpoint = `${this.namespace}/v1/upload?userId=` + userId + `&tenantId=` + tenantId + `&toReview=` + false;
    if (subjectCode !== null) {
      endpoint = endpoint + `&crosswalkTo=` + subjectCode;
    }
    if (progression !== null) {
      endpoint = endpoint + `&isProgression=` + progression;
    }
    const headers = http.getTokenHeaders();
    return http.upload(endpoint, formData, headers).then((res) => {
      return res;
    }).catch((error) => {
      const errorMsg = error && error.response && error.response.data && error.response.data.message ?
       JSON.parse(error.response.data.message).error : '';
      const errorObj = {
        status: error.response.status,
        errorMsg,
      };
      return errorObj;
    });
  }

  public delete(id: any): Promise<any> {
    const params = {

    };
    const endpoint = `${this.namespace}/v1/` + id + `/delete`;
    const headers = http.getTokenHeaders();
    return http.delete(endpoint, headers, params).then((res) => {
      return res;
    });
  }


  public fetchFileVersionById(id: any): Promise<any> {
    const endpoint = `${this.namespace}/v1/` + id + `/list`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return response.data;
    });

  }

  public previewFileVersionById(id: any): Promise<any> {
    const endpoint = `${this.namespace}/v1/` + id + `/preview`;
    const params = {};
    const headers = http.getTokenHeaders();
    return http.put(endpoint, headers, params).then((response) => {
      return response.data;
    });

  }

  public ingestFileVersionById(id: any): Promise<any> {
    const endpoint = `${this.namespace}/v1/` + id + `/publish`;
    const params = {};
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((response) => {
      return response.data;
    });

  }

}

export const competencyModelAPI = CompetencyModelAPI.instance;
